module.exports = __webpack_public_path__ + "3f3d2c6d3dabcfcb7c56c1a059e59ba4.png";